export default class BUtil {
  /**
   * 获取随机数
   * @param {*} minNum 最小值
   * @param {*} maxNum 最大值（不含）
   * @param {*} step 随机间隔
   * @returns 
   */
  static getRandomNumber(minNum, maxNum, step) {

    switch (arguments.length) {
      case 1:
        return parseInt(Math.random() * minNum + 1, 10);
        break;
      case 2:
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
        //或者 Math.floor(Math.random()*( maxNum - minNum + 1 ) + minNum );
        break;
      case 3:
        let _step = 1
        if (step != undefined) {
          _step = step
        }
        let _min = minNum / _step
        let _max = maxNum / _step

        return parseInt(Math.random() * (_max - _min + 1) + _min, 10) * _step;
        //或者 Math.floor(Math.random()*( maxNum - minNum + 1 ) + minNum );
        break;
      default:
        return 0;
        break;
    }
  }

  
}
